import React, { useEffect, useRef, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

function MoreNavMenu({ items = [], className = 'hidden sm:block' }) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (!items.length) {
    return null;
  }

  const isSecondaryActive = items.some(
    (item) =>
      location.pathname === item.to ||
      location.pathname.startsWith(`${item.to}/`),
  );

  return (
    <div ref={containerRef} className={`relative ${className}`}>
      <button
        type="button"
        onClick={() => setIsOpen((open) => !open)}
        className={`inline-flex items-center gap-1.5 text-sm transition-colors ${
          isSecondaryActive || isOpen
            ? 'text-forge-600 font-medium'
            : 'text-content-muted hover:text-content-primary'
        }`}
        aria-haspopup="menu"
        aria-expanded={isOpen}
      >
        Mais
        <ChevronDown className={`h-4 w-4 shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} aria-hidden />
      </button>

      {isOpen && (
        <div
          className="absolute left-0 mt-2 min-w-[180px] rounded-lg border border-slate-200 bg-white shadow-lg z-50 py-1"
          role="menu"
        >
          {items.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              role="menuitem"
              className={({ isActive }) =>
                `flex items-center gap-2 px-3 py-2 text-sm transition-colors ${
                  isActive
                    ? 'bg-forge-50 text-forge-700 font-medium'
                    : 'text-content-primary hover:bg-slate-50'
                }`
              }
              onClick={() => setIsOpen(false)}
            >
              <Icon className="h-[18px] w-[18px] shrink-0" aria-hidden />
              {label}
            </NavLink>
          ))}
        </div>
      )}
    </div>
  );
}

export default MoreNavMenu;
